import { render, staticRenderFns } from "./RecursiveTable.vue?vue&type=template&id=237bf016&scoped=true"
import script from "./RecursiveTable.vue?vue&type=script&lang=js"
export * from "./RecursiveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237bf016",
  null
  
)

export default component.exports